import React, { useContext, useMemo, useState } from "react";
import { Table, Button } from "antd";
import { VerticalAlignBottomOutlined } from "@ant-design/icons";
import { Card } from "antd";
import CommonFilter from "../modules/CommonFilter";

import getPageLabels from "../../Utils/Label.service";
import { DONATIONSRECIEVEDBYDONOR_PAGE_LABELS } from "../../Utils/Labels/DonationsReceivedByDonor.page.labels";
import { i18n } from "../../App";
import DonationRecievedByDonorFilter from "../../Filters/DonationRecievedByDonorFilter";
import { CSVLink } from "react-csv";
const items = [
  {
    label: <div>Donation ID</div>,
    key: "0",
  },
  {
    label: <div>Transaction ID</div>,
    key: "1",
  },

  {
    label: <div>Donor ID</div>,
    key: "3",
  },
  {
    label: <div>Donor Name</div>,
    key: "4",
  },
  {
    label: <div>Total Donated Amount</div>,
    key: "5",
  },
  {
    label: <div>Donation Date</div>,
    key: "6",
  },
];

function DonationRecievedByDonor() {
  const { language } = useContext(i18n);

  const lang = useMemo(
    () =>
      getPageLabels(DONATIONSRECIEVEDBYDONOR_PAGE_LABELS, language.language),
    [language]
  );
  const columns = [
    {
      title: lang.donor_id,
      dataIndex: "donor_id",
    },
    {
      title: lang.donor_name,
      dataIndex: "first_name",
    },
    {
      title: lang.public_id,
      dataIndex: "public_id",
    },
    {
      title: lang.donation_id,
      dataIndex: "reference_no",
    },

    {
      title: lang.month,
      dataIndex: "month",
    },
    {
      title: lang.year,
      dataIndex: "year",
    },
    {
      title: lang.date,
      dataIndex: "date",
    },
    {
      title: lang.category,
      dataIndex: "category",
    },

    {
      title: lang.amount,
      dataIndex: "amount",
    },
  ];
  const [data, setData] = useState([]);

  return (
    <div>
      <div className="row">
        <div className="col-md-12">
          <DonationRecievedByDonorFilter set={setData} />
        </div>
      </div>

      <div className="mt-4">
        <Card>
          <div className="d-flex align-items-center justify-content-between">
            <div className="fos-heading ml-2"> {lang.heading}</div>
            <CSVLink
              data={data}
              headers={columns.map((col) => ({
                label: col.title,
                key: col.dataIndex,
              }))}
              filename={"donations_by_donor.csv"}
              className="download-button"
            >
              {lang.download_report} <VerticalAlignBottomOutlined />
            </CSVLink>
          </div>
          <Table className="mt-3" columns={columns} dataSource={data} />
        </Card>
      </div>
    </div>
  );
}

export default DonationRecievedByDonor;
